import $http from '@/plugins/axios'
import $utils from "@/utils/utils";

const AdminService = {
    exportCampaignUser (campaignId) {
        return $http.get('admin/campaigns/export-campaign-user/?campaign_id=' + campaignId, {
            responseType: 'blob'
        }).then(response => {
            $utils.downloadFileFromBlob(response.data, 'campaign-user.xlsx')
        })
    }
}

export default AdminService
